import { lazy, ReactNode, Suspense } from "react"

import { EditorSelectionConfig } from "./types"

const TiptapEditor = lazy(() =>
  import("./tiptap-editor").then((m) => ({ default: m.default }))
)

type Props = {
  content: string | undefined
  toolbarItems?: () => ReactNode
  onUpdate?: (val: string) => void
  onBlur?: (val: string) => void
  selectionConfig?: EditorSelectionConfig
  isEditable?: boolean
  className?: string
  hideToolBar?: boolean
  editorInstanceRef?: any
  placeholder?: string
  footer?: ReactNode | null
  contentClassName?: string
  hardBreaks?: boolean
}

function RichTextEditor({
  content,
  toolbarItems,
  onUpdate,
  onBlur,
  selectionConfig,
  editorInstanceRef,
  isEditable = false,
  ...rest
}: Props) {
  return (
    <Suspense fallback={<div className="rich-editor-loading" />}>
      <TiptapEditor
        {...rest}
        isEditable={isEditable}
        content={content}
        selectionConfig={selectionConfig}
        toolbarItems={toolbarItems}
        onUpdate={onUpdate}
        onBlur={onBlur}
        editorInstanceRef={editorInstanceRef}
      />
    </Suspense>
  )
}

export default RichTextEditor
